const isLessThanAWeekAgo = (date: Date) => {
    return date.getTime() > Date.now() - 1000 * 60 * 60 * 24 * 7;
};

export default isLessThanAWeekAgo;
